module.exports = __webpack_public_path__ + "static/service-banner-watch-e530c75dc81a3a27d341b2f9e5e68ae7.jpeg";